@if (cropFieldTreatmentsTableConfig) {
  <agr-table [config]="cropFieldTreatmentsTableConfig"> </agr-table>
}
